/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-11-03 16:02:48
 */
import React from 'react'
import { useGroupLimitInfo } from '../../app/hooks/useGroupLimitInfo'
const HooksBridge = () => {
  useGroupLimitInfo()
  return null
}

export default HooksBridge
